<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
	export interface StateOpt {
		state: string;
		abbr: string;
	}

	export function getStateAbbr(state: string) {
		state = state.toLowerCase();
		for (let _state of US_states) {
			if (_state.abbr.toLowerCase() == state || _state.state.toLowerCase() == state) {
				return _state.abbr;
			}
		}
		return null;
	}

	export function getStateFullName(state: string) {
		state = state.toLowerCase();
		for (let _state of US_states) {
			if (_state.abbr.toLowerCase() == state || _state.state.toLowerCase() == state) {
				return _state.state;
			}
		}
		return null;
	}
	export let US_states: StateOpt[] = [
		{ state: 'Alabama', abbr: 'AL' },
		{ state: 'Alaska', abbr: 'AK' },
		{ state: 'Arizona', abbr: 'AZ' },
		{ state: 'Arkansas', abbr: 'AR' },
		{ state: 'California', abbr: 'CA' },
		{ state: 'Colorado', abbr: 'CO' },
		{ state: 'Connecticut', abbr: 'CT' },
		{ state: 'Delaware', abbr: 'DE' },
		{ state: 'Florida', abbr: 'FL' },
		{ state: 'Georgia', abbr: 'GA' },
		{ state: 'Hawaii', abbr: 'HI' },
		{ state: 'Idaho', abbr: 'ID' },
		{ state: 'Illinois', abbr: 'IL' },
		{ state: 'Indiana', abbr: 'IN' },
		{ state: 'Iowa', abbr: 'IA' },
		{ state: 'Kansas', abbr: 'KS' },
		{ state: 'Kentucky', abbr: 'KY' },
		{ state: 'Louisiana', abbr: 'LA' },
		{ state: 'Maine', abbr: 'ME' },
		{ state: 'Maryland', abbr: 'MD' },
		{ state: 'Massachusetts', abbr: 'MA' },
		{ state: 'Michigan', abbr: 'MI' },
		{ state: 'Minnesota', abbr: 'MN' },
		{ state: 'Mississippi', abbr: 'MS' },
		{ state: 'Missouri', abbr: 'MO' },
		{ state: 'Montana', abbr: 'MT' },
		{ state: 'Nebraska', abbr: 'NE' },
		{ state: 'Nevada', abbr: 'NV' },
		{ state: 'New Hampshire', abbr: 'NH' },
		{ state: 'New Jersey', abbr: 'NJ' },
		{ state: 'New Mexico', abbr: 'NM' },
		{ state: 'New York', abbr: 'NY' },
		{ state: 'North Carolina', abbr: 'NC' },
		{ state: 'North Dakota', abbr: 'ND' },
		{ state: 'Ohio', abbr: 'OH' },
		{ state: 'Oklahoma', abbr: 'OK' },
		{ state: 'Oregon', abbr: 'OR' },
		{ state: 'Pennsylvania', abbr: 'PA' },
		{ state: 'Rhode Island', abbr: 'RI' },
		{ state: 'South Carolina', abbr: 'SC' },
		{ state: 'South Dakota', abbr: 'SD' },
		{ state: 'Tennessee', abbr: 'TN' },
		{ state: 'Texas', abbr: 'TX' },
		{ state: 'Utah', abbr: 'UT' },
		{ state: 'Vermont', abbr: 'VT' },
		{ state: 'Virginia', abbr: 'VA' },
		{ state: 'Washington', abbr: 'WA' },
		{ state: 'West Virginia', abbr: 'WV' },
		{ state: 'Wisconsin', abbr: 'WI' },
		{ state: 'Wyoming', abbr: 'WY' }
	];
</script>

<script lang="ts">
	import { onMount } from 'svelte';

	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import type { Component, StateSelector } from '@prisma/client';
	export let Valid = false;
	export let Value: null | string = '';
	export let Config: StateSelector & Component;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	let autocompleteEl: HTMLElement;
	let inputEl: HTMLInputElement;
	let ErrorEl: HTMLElement;
	let ErrorMsg: string = 'Error';
	let mdb_dealerStateAutocomplete;

	const stateFilter = (value) => {
		return US_states.filter((state) => {
			return (
				state.state.toLowerCase().includes(value.toLowerCase()) ||
				state.abbr.toLowerCase().includes(value.toLowerCase())
			);
		});
	};

	async function createAutocomplete() {
		const { Autocomplete } = await import('mdb-ui-kit');
		mdb_dealerStateAutocomplete = new Autocomplete(autocompleteEl, {
			filter: stateFilter,
			debounce: 300,
			displayValue: (value: StateOpt) => {
				if ('state' in value) {
					return value.state;
				} else {
					return value;
				}
			},
			itemContent: (result: StateOpt) => {
				return `
        <div class="autocomplete-custom-item-content">
          <div class="autocomplete-custom-item-title">${result.state} (${result.abbr})</div>
        </div>
      `;
			}
		});
	}

	let mdb;
	onMount(async () => {
		mdb = await import('mdb-ui-kit');
		//new Input(autocompleteEl).init();
		await createAutocomplete();
		// 	autocompleteEl.addEventListener('open.mdb.autocomplete', (e) => {
		// 		if (!inputEl.value || inputEl.value == '') {
		// 			return;
		// 		}
		// 		let stateAbbr = getStateAbbr(inputEl.value);
		// 		let stateFull = null;
		// 		if (stateAbbr) {
		// 			stateFull = getStateFullName(stateAbbr);
		// 		}
		// 		console.log(
		// 			'inputEl.value',
		// 			inputEl.value,
		// 			'mdb_dealerStateAutocomplete._filteredResults',
		// 			mdb_dealerStateAutocomplete._filteredResults
		// 		);
		// 		if (mdb_dealerStateAutocomplete._filteredResults.length == 1) {
		// 			let stateAbbr = mdb_dealerStateAutocomplete._filteredResults[0].abbr;
		// 			inputEl.value = stateFull != null ? stateFull : '';
		// 			Value = stateAbbr;
		// 			setTimeout(() => {
		// 				mdb_dealerStateAutocomplete.close();
		// 				mdb_dealerStateAutocomplete.dispose();
		// 				createAutocomplete();
		// 			}, 2000);
		// 		}
		// 	});
	});
	export function validate(e?: Event) {
		if (inputEl.value == '') {
			if (Config.Required) {
				inputEl.classList.add('is-invalid');
			}
		} else {
			let stateAbbr = getStateAbbr(inputEl.value);
			let stateFull = null;
			if (stateAbbr) {
				stateFull = getStateFullName(stateAbbr);
			}
			if (stateAbbr == null) {
				console.log('filtered Results:', mdb_dealerStateAutocomplete._filteredResults);
				if (mdb_dealerStateAutocomplete._filteredResults.length == 1) {
					stateAbbr = mdb_dealerStateAutocomplete._filteredResults[0].abbr;
					inputEl.value = stateFull != null ? stateFull : '';
					Value = stateAbbr;
					setValid();
				} else {
					//dealerListAutocompleteObj.dispose();
					//lastLookup = ''
					//$('#dealerStateSelect').val('')
					inputEl.value = '';
					if (Config.Required) {
						setInvalid('Required field');
						return false;
					} else {
						setNuetral();
					}
				}
			} else {
				inputEl.value = stateFull ? stateFull : stateAbbr;
				console.log('setting Value:', stateAbbr);
				Value = stateAbbr;
				setValid();
			}
		}
		inputEl.classList.remove('is-invalid');
		return true;
	}
	function setNuetral() {
		// if (Required) {
		// 	return;
		// }
		inputEl.classList.remove('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
	}
	export function setInvalid(errMsg?: string) {
		if (errMsg) {
			ErrorMsg = errMsg;
		}
		Valid = false;
		inputEl.classList.add('is-invalid');
		inputEl.classList.remove('is-valid');
		if (ErrorMsg) {
			ErrorEl.style.display = 'block';
		} else {
			ErrorEl.style.display = 'none';
		}
	}
	export function setValid() {
		Valid = true;
		inputEl.classList.add('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
		//Event.trigger('addressValid');
	}
	export function appendData(formData: FormData) {
		if (!Value) {
			console.error('StateSelector Value is not set');
			return;
		}
		console.log('getting formData from name');
		let colName = 'state';
		formData.append(Config.DBCol + colName, Value);
	}
	export function focus() {
		inputEl.focus();
	}
	export function onChange(e: Event) {
		inputElValue = inputEl.value;
		if (validate(e)) {
		}
	}
	let inputElValue = '';
</script>

<FormGroup {Config}>
	{#if Config.Title}<div class="title3">{Config.Title}</div>
	{/if}
	<div class="col-6">
		<div class="col" class:required={Config.Required}>
			<div class="form-outline" bind:this={autocompleteEl}>
				<input
					class="form-control"
					id="dealerStateSelect"
					type="text"
					on:blur={validate}
					on:change={onChange}
					bind:this={inputEl}
					bind:value={inputElValue}
					class:active={Value != ''}
					disabled={Disabled}
					readonly={ReadOnly}
				/>
				<div class="form-notch">
					<div class="form-notch-leading" style="width: 9px;" />
					<div class="form-notch-middle" style="width: 40.6px;" />
					<div class="form-notch-trailing" />
				</div>
				<label class="form-label" for="dealerStateSelect">State</label>
				<div class="autocomplete-custom-content" />
				<div class="invalid-tooltip hidden" id="dealerStateSelectInfo" bind:this={ErrorEl}>
					{ErrorMsg}
				</div>
				<div class="msg-spacer" />
			</div>
		</div>
	</div>
</FormGroup>
